<template>
  <div class="content-wrapper">
    <SendGiftMenu
      header="Shipping"
      back-to="ShoppingBag"
      :display-stepper="true"
    />
    <RecipientForm />
  </div>
</template>

<script>
import RecipientForm from '@/components/SendGiftFlow/RecipientForm'
import SendGiftMenu from '@/components/SendGiftMenu'
import { layouts, storeModules } from '../../helpers'
import store from '../../store'

export default {
  name: 'SelectRecipent',
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (
      store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
    ) {
      next()
    } else if (
      store.state.team.team.teamModuleNames.includes(storeModules.project)
    ) {
      next({ name: 'Projects' })
    }
  },
  computed: {
    isEditing() {
      return parseInt(this.$route.query.editing || '') === 1
    }
  },
  components: {
    RecipientForm,
    SendGiftMenu
  },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  }
}
</script>

<style>
@media (max-width: 1100px) {
  form {
    width: 90%;
  }
}
</style>
